import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import ErrorBoundary from "./components/ErrorBoundary";

import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import FeedPage from "./pages/FeedPage";
import PostDetailPage from "./pages/PostDetailPage";
import ProfilePage from "./pages/ProfilePage";
import BookmarksPage from "./pages/BookmarksPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import CollectionsPage from "./pages/CollectionsPage";
import CollectionDetailPage from "./pages/CollectionDetailPage";
import AdminPage from "./pages/AdminPage";

function Protected({ children }) {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
                <div className="text-stone-500 text-sm font-mono tracking-wider uppercase">Loading…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
}

function PublicOnly({ children }) {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
                <div className="text-stone-500 text-sm font-mono tracking-wider uppercase">Loading…</div>
            </div>
        );
    }
    if (user) return <Navigate to="/feed" replace />;
    return children;
}

function App() {
    return (
        <div className="App">
            <ErrorBoundary>
                <AuthProvider>
                    <BrowserRouter>
                        <Toaster position="top-right" richColors />
                        <Routes>
                            <Route path="/" element={<ErrorBoundary><LandingPage /></ErrorBoundary>} />
                            <Route path="/login" element={<ErrorBoundary><PublicOnly><LoginPage /></PublicOnly></ErrorBoundary>} />
                            <Route path="/register" element={<ErrorBoundary><PublicOnly><RegisterPage /></PublicOnly></ErrorBoundary>} />
                            <Route path="/forgot-password" element={<ErrorBoundary><ForgotPasswordPage /></ErrorBoundary>} />
                            <Route path="/reset-password" element={<ErrorBoundary><ResetPasswordPage /></ErrorBoundary>} />
                            <Route path="/verify-email" element={<ErrorBoundary><VerifyEmailPage /></ErrorBoundary>} />
                            <Route path="/feed" element={<ErrorBoundary><Protected><FeedPage /></Protected></ErrorBoundary>} />
                            <Route path="/bookmarks" element={<ErrorBoundary><Protected><BookmarksPage /></Protected></ErrorBoundary>} />
                            <Route path="/collections" element={<ErrorBoundary><Protected><CollectionsPage /></Protected></ErrorBoundary>} />
                            <Route path="/collections/:id" element={<ErrorBoundary><Protected><CollectionDetailPage /></Protected></ErrorBoundary>} />
                            <Route path="/admin" element={<ErrorBoundary><Protected><AdminPage /></Protected></ErrorBoundary>} />
                            <Route path="/posts/:id" element={<ErrorBoundary><Protected><PostDetailPage /></Protected></ErrorBoundary>} />
                            <Route path="/users/:id" element={<ErrorBoundary><Protected><ProfilePage /></Protected></ErrorBoundary>} />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </BrowserRouter>
                </AuthProvider>
            </ErrorBoundary>
        </div>
    );
}

export default App;
